<template>
  <div class="invitation h-screen">
    <InvitationComponent v-if="currentPage == 0" />
  </div>
</template>

<script>
import InvitationComponent from "@/components/invitation/InvitationComponent.vue"

export default {
  name: "Invitation",
  components:{
    InvitationComponent
  },
  data(){
    return{
    currentPage: 0
    }
  },
  methods:{
    skipForward(){
        this.currentPage = 1
    }
  },
  mounted(){
    Event.$emit('playAudio', 'Invitation');
    Event.$on('skipInvitationForward', () => {this.skipForward()});
  }
}
</script>

<style lang="css" scoped>
</style>
